import './EntityLimitsTable.scss';

import { SonarTable } from '@ui/SonarTable';
import { SortOrder } from 'antd/es/table/interface';
import { useApiResource } from '@hooks';

import { EntityLimit, getColumns } from './EntityLimitsTableColumns';
import React, { useMemo } from 'react';

export interface EntityLimitsTableProps {
    sonarObjectId: number;
}

const getRowKey = (limit: EntityLimit) => limit.id;
const sortDirections: Array<SortOrder> = [ 'ascend', 'descend', 'ascend' ];

export const EntityLimitsTable: React.FC<EntityLimitsTableProps> = ({ sonarObjectId }) => {
	const { loading, resource } = useApiResource<Array<EntityLimit>>(
		`v2/salesforce/SfEntityDefinitions/${sonarObjectId}/limits`
	);

	const columns = useMemo(getColumns, []);

	return (
		<SonarTable
			className='entity-limits-table'
			columns={ columns }
			dataSource={ resource }
			loading={ loading }
			pagination={ false }
			rowKey={ getRowKey }
			sortDirections={ sortDirections }
			sticky />
	);
};
